module.exports = __webpack_public_path__ + "static/media/torrot.b4a613de.png";